import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createBrand } from "../../api/apiBrands";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء علامة تجارية جديدة
 */
export function useCreateBrand() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createBrandMutate,
        isPending: isCreating,
    } = useMutation({
        mutationFn: createBrand,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["brands"] });
            navigate('/brands');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create brand");
        },
    });

    return {
        createBrandMutate,
        isCreating,
    };
}
